import { render } from "./AvatarUpload.vue?vue&type=template&id=1931da34"
import script from "./AvatarUpload.vue?vue&type=script&lang=js"
export * from "./AvatarUpload.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__